var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachinationsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 20,
    viewBox: "0 0 43 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4596 2.23071L22.8111 15.9425C22.2314 16.9818 21.9416 17.5014 21.5011 17.5014C21.0607 17.5014 20.7709 16.9818 20.1912 15.9425L12.5426 2.23071C11.9884 1.23718 11.7113 0.740418 11.9288 0.370209C12.1462 0 12.715 0 13.8526 0H29.1496C30.2873 0 30.8561 0 31.0735 0.370209C31.2909 0.740418 31.0138 1.23718 30.4596 2.23071Z",
    fill: "#5A55F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6601 13.4109C13.8404 14.9754 13.0216 16.9398 12.7207 18.4404C12.5578 19.2532 12.4763 19.6596 12.269 19.8295C12.0616 19.9994 11.7108 19.9994 11.0092 19.9994H2.73824C1.62661 19.9994 1.07079 19.9994 0.852082 19.6366C0.63337 19.2739 0.892799 18.7823 1.41166 17.7992L8.96898 3.47996C9.53082 2.41541 9.81174 1.88313 10.2549 1.87532C10.6981 1.8675 10.9976 2.38954 11.5966 3.43363L16.1083 11.2974C16.4348 11.8665 16.5981 12.151 16.5525 12.417C16.5068 12.683 16.2246 12.9256 15.6601 13.4109Z",
    fill: "#5A55F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3399 13.4109C29.1596 14.9754 29.9784 16.9398 30.2793 18.4404C30.4422 19.2532 30.5237 19.6596 30.731 19.8295C30.9384 19.9994 31.2892 19.9994 31.9908 19.9994H40.2618C41.3734 19.9994 41.9292 19.9994 42.1479 19.6366C42.3666 19.2739 42.1072 18.7823 41.5883 17.7992L34.031 3.47996C33.4692 2.41541 33.1883 1.88313 32.7451 1.87532C32.3019 1.8675 32.0024 2.38954 31.4034 3.43363L26.8917 11.2974C26.5652 11.8665 26.4019 12.151 26.4475 12.417C26.4932 12.683 26.7754 12.9256 27.3399 13.4109Z",
    fill: "#5A55F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachinationsLogo);
export default __webpack_public_path__ + "static/media/machinationsLogo.1ebcf117ba22ee1ac6040c98c7807525.svg";
export { ForwardRef as ReactComponent };